export default "__VITE_ASSET__Dt5P1Es7__"